import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import warningImage from '../../../../assets/promo/warning.png';
import { useStores } from '../../../../stores/useStores';
import Button from '../../../buttons/Button';
import { DialogBox } from '../../../Dialog/DialogBox';
import { DialogContent } from '../../../Dialog/DialogContent';
import { DialogHeader } from '../../../Dialog/DialogHeader';

import { getInvalidPromoCodeToMsgMap } from './constants';
import styles from './InvalidPromoDialog.module.scss';
import type { InvalidPromoErrorReason } from './types';

const InvalidPromoDialog = observer(() => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { portalStore, promotionStore } = useStores();
  const { t } = useTranslation();

  const { options } = portalStore;

  const removePcQueryParam = () => {
    if (searchParams.has('pc')) {
      searchParams.delete('pc');
      setSearchParams(searchParams);
    }
  };

  const closeDialog = () => {
    removePcQueryParam();
    promotionStore.closePromotionDialog();
  };

  const onCloseClickHandler = () => {
    promotionStore.sendAnalyticsEvent({ event_action: 'click', click_location: 'close' });
    closeDialog();
  };

  const onCtaClickHandler = () => {
    promotionStore.sendAnalyticsEvent({ event_action: 'click', click_location: 'cta', button_text: 'Ok' });
    closeDialog();
  };

  const errorCode = options.errorCode as InvalidPromoErrorReason;
  const errorMsg = getInvalidPromoCodeToMsgMap()[errorCode || 'PromoCodeInactiveError'];

  return (
    <DialogBox>
      <DialogHeader title={`${t('dialogs.oops')}`} onClose={onCloseClickHandler} />

      <DialogContent className={styles.content}>
        <p className={styles.invalidPromoReason}>{errorMsg}</p>
        <img alt="Warning" className={styles.warningImg} src={warningImage} />
        <Button btnType="main" onClick={onCtaClickHandler}>
          {t('common.buttons.okLowerCase')}
        </Button>
      </DialogContent>
    </DialogBox>
  );
});

export default InvalidPromoDialog;
